<template>
  <div v-if="show">
    <a-select
      class="w-[105px]"
      :value="watchfaceStore.description?.watchfaceType ?? 'normal'"
      placeholder="无"
      :options="options"
      :disabled="!!attrDisabled"
      size="middle"
      @change="onSelect"
    >
      <template #suffixIcon>
        <span class="flex items-center">
          <icon icon="arrow-down3.svg" :width="14" :height="14" fill="none" />
        </span>
      </template>
    </a-select>
    <div class="opacity-70 text-xs ml-6 -mb-[2px] mt-1">表盘类型</div>
  </div>
</template>

<script setup lang="ts">
import { Description } from '@/types/watchface';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { useEditorStore } from '@/store/use-editor-store';
import { computed } from 'vue';
import { emitter, EventType } from '@/utils/emitter.utils';
import { Modal } from 'ant-design-vue';
import { useWatchfaceAndroid, useWathchfaceType } from '@/hooks';
import { useLayerStore } from '@/store/use-layer-store';
import { Shape, ShapeType } from '@/services/shape';

const show = computed(() => {
  return options.value.length > 1;
});

const watchfaceStore = useWatchfaceStore();
const editorStore = useEditorStore();
const attrDisabled = computed(() => !!editorStore.attrDisabled);
const { androidWatcfaceOS } = useWatchfaceAndroid();
const { getSupportWatchfaceTypes } = useWathchfaceType();
const layerStore = useLayerStore();

const options = computed(() => {
  return getSupportWatchfaceTypes(watchfaceStore.deviceType);
});

const resetPhotoAlbumFg = () => {
  const themes = layerStore.themes as StoreThemeItem[];
  const shapes = themes
    .map((theme) => {
      return theme.children.filter(
        (shape) => shape.type == ShapeType.PhotoAlbumBg
      );
    })
    .flat()
    .map((item) => Shape.getShape(item.id));

  for (const shape of shapes) {
    if (!shape) return;
    shape.deleteResource({ resourceName: 'photoAlbumFg' });
  }
};

const onSelect = async (val: Description['watchfaceType']) => {
  if (watchfaceStore.watchfaceType == val) return;
  if (val === 'videoWatchface' && androidWatcfaceOS.value == 'vela') {
    Modal.warning({
      title: '提示',
      content: '轻智能类型不支持视频表盘'
    });
    return;
  }

  // 切换至其他表盘类型时清空人像表盘 BPGJ-778
  if (val !== 'portrait') {
    resetPhotoAlbumFg();
  }

  await watchfaceStore.update({
    watchfaceType: val
  });

  emitter.emit(EventType['watchface:type-changed'], { type: val });
};
</script>

<style lang="less" scoped>
._grid {
  display: grid;
  grid-template-columns: 150px 20px;
  align-items: center;
}

:deep(.ant-select-selector) {
  border-radius: 4px !important;
  height: 30px !important;
  .ant-select-selection-item.ant-select-selection-item {
    bottom: 2.5px;
  }
}
:deep(.ant-select-arrow) {
  right: 15px;
}
:deep(.ant-select-disabled .ant-select-arrow) {
  opacity: 0.3;
}
</style>
